import React from 'react';
import {observer} from 'mobx-react';

import {Col, DatePicker, Row} from "antd";
import MySearchComponent from '@ViewsDashboard/Common/MySearchComponent';

import turn_store, {filter_store} from '@store/Statistic/TurnToCharge/TurnToChargeStore';

const {RangePicker} = DatePicker;

@observer
class TurnToChargeFilterFrom extends React.Component {
    render() {
        let numberStyle = {fontSize: '16px', fontWeight: '600', marginRight: '15px', float: 'right'};
        let tipStyle = {marginLeft: '3px', float: 'right'};
        let genAmount = '转充总额:';
        let sAmount = '赠送金额:';
        return (
            <Row type={"flex"} style={{flex: '1'}}>
                {<Col style={{lineHeight: '34px'}}>
                    <MySearchComponent
                        defaultValue={{
                            nick_name: filter_store.nick_name ? filter_store.nick_name : '',
                            pet_name: filter_store.pet_name ? filter_store.pet_name : '',
                            agent: filter_store.agent ? filter_store.agent : '',
                            search: filter_store.search ? filter_store.search : '',
                            date: filter_store.start_time != undefined ? [filter_store.start_time, filter_store.end_time] : []
                        }}
                        onClick={(values) => {
                            let pet_name = values.pet_name;
                            let agent = values.agent;
                            let search = values.search;
                            if (pet_name === '') {
                                pet_name = undefined
                            }
                            if (agent === '') {
                                agent = undefined
                            }
                            let filter = {
                                nick_name: filter_store.nick_name,
                                pet_name: filter_store.pet_name,
                                agent: agent,
                                search: search,
                                type_time: values.type_time || 6,
                            }
                            turn_store.reloadDatas(filter);
                        }}
                    />
                </Col>
                }
                <Col
                    style={{lineHeight: '34px', marginLeft: '10px', flex: 1, textAlign: 'right'}}>
                    <span style={numberStyle}>{Number(turn_store.sumDonationAmount).toFixed(2)}</span>
                    <span style={tipStyle}> {sAmount} </span>
                    <span style={numberStyle}>{Number(turn_store.sumInMoney).toFixed(2)}</span>
                    <span style={tipStyle}> {genAmount} </span>
                </Col>
            </Row>
        );
    }
}

export default TurnToChargeFilterFrom;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/Statistic/TurnToCharge/TurnToChargeFilterFrom.jsx